module.exports = "pegasus_template/assets/classic-twitter-old.png";